import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import TabelaDinamica from '~/Components/TabelaDinamica/Tabela';

// W-0627 — Tabela de resultado do relatório Carteira por Conta Capital.
// Fonte: Uqrcapital.pas band detalhe + rodapé soma/somadentro/somafora.
// PRD §6.3 (layout).

const fmtMoeda = (valor) => {
  if (valor == null) return '-';
  const n = Number(valor) || 0;
  return n.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const fmtInt = (valor) => {
  if (valor == null) return '-';
  return Number(valor).toLocaleString('pt-BR');
};

const colunas = [
  { title: 'Conta', key: 'conta', ordenacao: true, align: 'right', width: '100px' },
  { title: 'Apelido', key: 'apelido', ordenacao: true, align: 'left' },
  {
    title: 'Dentro (R$)',
    key: 'dentro',
    ordenacao: true,
    align: 'right',
    render: (v) => fmtMoeda(v),
  },
  {
    title: 'Fora (R$)',
    key: 'fora',
    ordenacao: true,
    align: 'right',
    render: (v) => fmtMoeda(v),
  },
  {
    title: 'Total (R$)',
    key: 'valor',
    ordenacao: true,
    align: 'right',
    render: (v) => fmtMoeda(v),
  },
  {
    title: 'PM (dias)',
    key: 'pm',
    ordenacao: true,
    align: 'right',
    width: '110px',
  },
];

const CarteiraResultadoTabela = ({ resultado, onExportar, exportando }) => {
  if (!resultado) return null;

  const dados = (resultado.linhas || []).map((r) => ({
    ...r,
    id: r.conta,
  }));

  return (
    <Card className="mt-3">
      <Card.Body>
        <Row className="mb-2 align-items-center">
          <Col>
            <h5 className="mb-0">Resultado</h5>
          </Col>
          <Col xs="auto">
            <Button
              variant="success"
              size="sm"
              onClick={onExportar}
              disabled={dados.length === 0 || exportando}
              title="Exportar resultado para Excel"
            >
              <FaFileExcel className="mr-1" />{' '}
              {exportando ? 'Exportando...' : 'Exportar Excel'}
            </Button>
          </Col>
        </Row>

        <TabelaDinamica colunas={colunas} dados={dados} />

        {dados.length > 0 && (
          <div
            style={{
              marginTop: '12px',
              padding: '10px 16px',
              backgroundColor: '#f1f5f9',
              borderRadius: '4px',
              fontSize: '0.9rem',
            }}
          >
            <Row>
              <Col xs={12} md={4}>
                <strong>Total Dentro:</strong>{' '}
                <span style={{ color: '#0747a6' }}>
                  R$ {fmtMoeda(resultado.total_dentro)}
                </span>
              </Col>
              <Col xs={12} md={4}>
                <strong>Total Fora:</strong>{' '}
                <span style={{ color: '#a40e26' }}>
                  R$ {fmtMoeda(resultado.total_fora)}
                </span>
              </Col>
              <Col xs={12} md={4}>
                <strong>Total Geral:</strong>{' '}
                <span style={{ fontWeight: 700 }}>
                  R$ {fmtMoeda(resultado.total_valor)}
                </span>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <strong>Contratos:</strong>{' '}
                {fmtInt(resultado.contratos_dentro)} dentro /{' '}
                {fmtInt(resultado.contratos_fora)} fora
              </Col>
            </Row>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default CarteiraResultadoTabela;
